module.exports = __webpack_public_path__ + "static/marche-ext-8f8da6dba8cb19acfd70ed9395e94249.ttf";